<template>
  <div>
    <div class="row mb-2">
      <div class="col-auto mr-auto">
        <h3>{{ $t("navigation." + constants.ROUTE_FOOD) }}</h3>
      </div>
      <div class="col-auto d-flex align-items-center">
        <div class="dropdown actions-icon-height mr-2">
          <v-icon
            :name="currentSort.name"
            :class="['actions-icon', { flip: currentSort.flip }]"
            :title="$t('sort.order')"
            id="sortDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            :aria-expanded="sortDropdownExpanded ? 'true' : 'false'"
            @click.prevent="sortDropdownExpanded = !sortDropdownExpanded"
            v-click-outside="collapseDropdown"
          />
          <div
            :class="[
              'dropdown-menu dropdown-menu-right',
              { show: sortDropdownExpanded }
            ]"
            aria-labelledby="sortDropdown"
          >
            <a
              class="dropdown-item d-flex"
              v-for="(icon, key) in sortIcons"
              :key="key"
              @click="changeSortIcon(key)"
            >
              <div class="align-self-center mr-auto">{{ $t(icon.title) }}</div>
              <v-icon
                :name="icon.name"
                :class="['actions-icon ml-3', { flip: icon.flip }]"
                :title="$t(icon.title)"
              />
            </a>
          </div>
        </div>

        <v-icon
          name="regular/plus-square"
          class="actions-icon"
          :title="$t('navigation.' + constants.ROUTE_NEW_FOOD)"
          @click="$router.push({ name: constants.ROUTE_NEW_FOOD })"
        />
      </div>
    </div>

    <transition-group mode="out-in" name="move" tag="div" class="row">
      <FoodCard
        v-for="keyObj in sortedFoodKeys"
        :key="keyObj.key"
        :id="keyObj.key"
        :foodItem="food[keyObj.key]"
      ></FoodCard>
      <NewItemCard :route="{ name: constants.ROUTE_NEW_FOOD }" key="new" />
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "vue-awesome/icons/regular/plus-square";
import "vue-awesome/icons/sort-alpha-down";
import "vue-awesome/icons/sort-alpha-down-alt";
import "vue-awesome/icons/history";
import * as constants from "./../../constants";
import FoodCard from "./FoodCard";
import NewItemCard from "./../NewItemCard";
import { sortObjectKeysBySubProperty } from "./../../tools";

export default {
  name: "FoodList",
  components: { FoodCard, NewItemCard },
  data() {
    return {
      constants,
      currentSort: {},
      sortIcons: {
        name: {
          name: "sort-alpha-down",
          title: "sort.name.asc",
          sort: { by: "name" }
        },
        nameDesc: {
          name: "sort-alpha-down-alt",
          title: "sort.name.desc",
          sort: { by: "name", desc: true }
        },
        updated: {
          name: "history",
          title: "sort.updated.desc",
          sort: { by: "updated", desc: true }
        },
        updatedDesc: {
          name: "history",
          flip: true,
          title: "sort.updated.asc",
          sort: { by: "updated" }
        }
      },
      sortDropdownExpanded: false
    };
  },
  props: {
    forceReload: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(["food"]),
    sortedFoodKeys() {
      return sortObjectKeysBySubProperty(this.food, this.currentSort.sort);
    }
  },
  methods: {
    ...mapActions(["fetchFood"]),
    changeSortIcon(key) {
      this.currentSort = this.sortIcons[key];
      localStorage.setItem("foodListSort", key);
    },
    collapseDropdown() {
      this.sortDropdownExpanded = false;
    }
  },
  created() {
    // when route changes, component is recreated every time - do not fetch the data every time,
    // only when forced via route props - e.g. after creating new food
    // see https://router.vuejs.org/guide/essentials/passing-props.html#boolean-mode
    if (this.forceReload) {
      this.fetchFood();
    }
    // set last used sort if available in local storage, otherwise keep default - by name asc
    const foodListSort = localStorage.getItem("foodListSort");
    this.currentSort = this.sortIcons[foodListSort ? foodListSort : "name"];
  }
};
</script>

<style scoped lang="scss">
.flip {
  transform: scale(-1, 1);
}
</style>
